import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M19.25 9.75L19.25 6C19.25 5.30964 18.6904 4.75 18 4.75L6 4.75C5.30964 4.75 4.75 5.30964 4.75 6L4.75 9.75M19.25 9.75L19.25 18C19.25 18.6904 18.6904 19.25 18 19.25L6 19.25C5.30964 19.25 4.75 18.6904 4.75 18L4.75 9.75M19.25 9.75L4.75 9.75" vectorEffect="non-scaling-stroke" />
		<Path d="M9.87868 16.6213L12 14.5M14.1213 12.3787L12 14.5M12 14.5L14.1213 16.6213M12 14.5L9.87868 12.3787" vectorEffect="non-scaling-stroke" />
	</SVG>
);
